import { logException } from "@wss/error-tracking";
import { Throwable } from "@wss/error-tracking/throwable";
import { toError } from "@wss/error-tracking/utils";
import { sendCustomerIoNewsletterSignupEvent } from "~/analytics/CustomerIo/EmailEvents";

// eslint-disable-next-line import/prefer-default-export
export async function submitEmail(
  emailaddress: string
): Promise<Throwable<string>> {
  const body = new FormData();
  body.append("emailaddress", emailaddress);

  try {
    const response = await fetch(`/api/subscribetoallemails/`, {
      method: "POST",
      body,
    });

    if (!response.ok) {
      throw new Error(response.statusText);
    }
    const { emailSignupEvent } = await import("~/gtm");

    emailSignupEvent(emailaddress);
    sendCustomerIoNewsletterSignupEvent(emailaddress);

    return { isError: false, value: emailaddress };
  } catch (error) {
    logException(error);
    return { isError: true, error: toError(error) };
  }
}
